module.exports = __webpack_public_path__ + "static/media/docs.689850b3.svg";